import React, { useEffect, useRef } from 'react';
import Draggable from 'react-draggable';
import { Resizable } from 're-resizable';

const CmPipWindow = ({ isOpen, onClose, content, path }) => {
  const windowRef = useRef(null);
  const resizableRef = useRef(null);
  // react-draggable falls back to ReactDOM.findDOMNode(this) when no
  // nodeRef is given — that API was removed entirely in React 19, so
  // Draggable/DraggableCore crashed on mount. re-resizable's <Resizable>
  // is a class component whose ref is the component instance (the real DOM
  // node lives at resizableRef.current.resizable), which Draggable's nodeRef
  // can't use directly since it needs a ref that already points to a real
  // node — hence this plain wrapper div that Draggable's position/transform
  // gets applied to instead.
  const dragNodeRef = useRef(null);

  useEffect(() => {
  }, [path]);

  if (!isOpen) return null;

  // Get the link using the path
  const iframeSrc = `${path || ''}`;

  // Toggle full-screen function
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      if (windowRef.current) {
        windowRef.current.requestFullscreen().catch((err) => {
        });
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <Draggable handle=".pip-header" nodeRef={dragNodeRef}>
      <div ref={dragNodeRef}>
      <Resizable
        ref={resizableRef}
        defaultSize={{
          width: '400px',
          height: '300px',
        }}
        minWidth="300px"
        minHeight="200px"
        maxWidth="100%"
        maxHeight="100vh"
        style={{
          position: 'absolute',
        }}
      >
        <div
          ref={windowRef}
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.25)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderRadius: '10px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
            zIndex: 100000,
            display: 'flex',
            flexDirection: 'column',
            transition: 'all 0.3s ease',
            color: '#fff',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            className="pip-header"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 15px',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'move',
            }}
          >
            <span>{content?.title || 'PiP Window'}</span>
            <div>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '18px',
                  cursor: 'pointer',
                  padding: '0 5px',
                  marginRight: '10px',
                }}
                onClick={toggleFullScreen}
                title="Toggle Full Screen"
              >
                □
              </button>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '18px',
                  cursor: 'pointer',
                  padding: '0 5px',
                }}
                onClick={onClose}
              >
                &times;
              </button>
            </div>
          </div>
          <div
            className="pip-content"
            style={{
              flex: 1,
              padding: '15px',
              width: '100%',
              height: '100%',
              boxSizing: 'border-box',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderBottomLeftRadius: '10px',
              borderBottomRightRadius: '10px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <iframe
              src={iframeSrc}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                objectFit: 'contain',
                fontSize: 'clamp(12px, 2vw, 14px)',
                padding: 'clamp(5px, 1vw, 10px)',
              }}
              title={content?.title || 'Embedded Content'}
              allowFullScreen
            />
          </div>
          <div
            style={{
              position: 'absolute',
              bottom: '5px',
              right: '5px',
              width: '20px',
              height: '20px',
              background: 'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%2715 18 21 12 15 6%27/%3E%3Cpolyline points=%279 18 15 12 9 6%27/%3E%3C/svg%3E") no-repeat center',
              backgroundSize: 'contain',
              opacity: 0.7,
              cursor: 'se-resize',
            }}
          />
        </div>
      </Resizable>
      </div>
    </Draggable>
  );
};

export default CmPipWindow;